<template>
  <div class="w-full h-screen bg-gray-900 flex items-center justify-center">
    <div class="p-10 border-r border-mm-colors-primary">
      <h1 class="text-6xl font-bold text-mm-colors-primary">
        404
      </h1>
    </div>
    <div class="p-10">
      <h1 class="text-6xl font-bold text-white">
        Page Not Found
      </h1>
    </div>
  </div>
</template>
